<template>
  <div>
    <el-dialog title="添加同行人" :visible.sync="dialogVisible" width="50%">
      <el-container>
        <el-main>
          <!--          同行人表单： 需要name， company， tel-->
          <el-form :inline="false" size="small" :model="peerAddForm" :rules="peerRules" ref="formPeerAdd"
                   class="content-main" label-width="80px"
                   label-position="left">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="peerAddForm.name"></el-input>
            </el-form-item>
            <el-form-item label="公司" prop="company">
              <el-input v-model="peerAddForm.company"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="tel">
              <el-input v-model="peerAddForm.tel"></el-input>
            </el-form-item>
            <el-form-item label="身份证" prop="idCardNo" v-if="!icHidden">
              <el-input v-model="peerAddForm.idCardNo"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="onDialogCancelClick">取消</el-button>
              <el-button type="primary" @click="onDialogEnsureClick">确认</el-button>
            </el-form-item>
          </el-form>

        </el-main>
      </el-container>
    </el-dialog>

    <my-notify-dialog :show="notify.show" :success="notify.success" :msg="notify.msg" :title="notify.title"
                      @dialogClose="onNotifyDialogClose"></my-notify-dialog>

    <!-- 必填校验提示：画在 2048 画布内（Element MessageBox 挂 body 在画布 transform 下点不动） -->
    <div v-if="tip.show" class="tip-mask">
      <div class="tip-card">
        <div class="tip-title">{{ tip.title }}</div>
        <div class="tip-msg">{{ tip.msg }}</div>
        <button class="ta-btn primary tip-ok" @click="tip.show = false">{{ tip.okText }}</button>
      </div>
    </div>

    <!-- theme-a：居中标题 + 右上圆返回 + 卡片表单（字段模板由后端 getFields 驱动） -->
    <div class="common-page-box">
      <div class="back-btn" @click="$router.back()">
        <svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="#1a1d21" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>
      </div>

      <div class="page-title" style="font-size:64px;margin-top:48px">{{ title }}</div>

      <!-- overflow 不能 hidden：事由下拉 popper 改为画布内渲染（:popper-append-to-body="false"），
           hidden 会把下拉面板裁没（视觉+命中都没了） -->
      <div class="card" style="margin:40px 96px 16px;flex:1;padding:64px 88px 32px;display:flex;flex-direction:column;overflow:visible">
        <el-form ref="mainForm" :model="formData" :rules="mainFormRules" class="content-main-form" label-width="180px"
                 label-position="left" style="flex:1;overflow:auto">
          <div class="field-row" style="flex-basis:100%;margin:0 0 40px">
            <span class="field-label">被访人</span>
            <span style="font-size:36px;font-weight:600">{{ this.employee.name }}</span>
          </div>

          <template v-for="item in defaultFormTemplate">
            <el-form-item v-if="item.name !== 'visitorIdCard' || idCardMode > 1" :prop="item.name"
                          class="content-item" :label="item.title" :key="item.id">
              <el-input @blur="onMainLossFocus(item)" v-if="item.type === 'input'" class="input-width"
                        v-model="formData[item.name]"></el-input>
            </el-form-item>
          </template>


          <template v-for="item in formTemplate">
            <el-form-item v-if="item.id !== 2 && item.id !== 3" :prop="item.name" class="content-item"
                          :label="item.title" :key="item.id" :required="item.required ===1">

              <el-input
                  v-if="item.type === 'input' || item.type === 'company' || item.type === 'comments'"
                  :ref="item.id"  @focus="onGetFocus(item)" @blur="onLossFocus(item)"
                  class="input-width" v-model="formData[item.name]" :disabled="item.extIsReadyOnly">
              </el-input>

              <el-date-picker
                  v-else-if="item.type === 'timer'|| item.type === 'beginTime'|| item.type === 'endTime'"
                  type="datetime"
                  :editable="false"
                  class="input-width" v-model="formData[item.name]">
              </el-date-picker>

            <template v-else-if="item.type === 'car_num' || item.type === 'car'">

                <el-input :readonly="true" @click.native="onCarInputClick(item)" class="input-width"
                          v-model="formData[item.name]" :disabled="item.extIsReadyOnly"  @focus="onGetFocus(item)" @blur="onLossFocus(item)"
                          :ref="item.id"></el-input>
              </template>

              <template v-else-if="item.type === 'file'">
                <el-input class="input-width" disabled v-model="formData[item.name]" placeholder="暂不支持"></el-input>
              </template>

              <template v-else-if="item.type === 'number'">
                <el-input class="input-width" v-model="formData[item.name]" :ref="item.id"  @focus="onGetFocus(item)" @blur="onLossFocus(item)" ></el-input>
              </template>

              <template v-else-if="item.type === 'reason'">
                <!-- 有限选项平铺 chips：el-select 的 popper 画布内会被滚动层裁剪、
                     挂 body 又脱离画布缩放字号错位，chips 是平板端最稳的交互 -->
                <div class="chip-row">
                  <button v-for="child in item.valueListParse" :key="child.value" type="button"
                          class="chip" :class="{ active: formData[item.name] === child.value }"
                          @click="onReasonChipClick(item, child)">{{ child.value }}</button>
                </div>
              </template>

              <template
                  v-else-if="item.type === 'picker' || item.type === 'address' || item.type === 'list'  || item.type === 'reason' ">
                <el-select v-model="formData[item.name]" class="input-width"
                           :popper-append-to-body="false"
                           @change="onSelectChange(item, item.valueListParse, formData[item.name])" clearable
                           :disabled="item.extIsReadyOnly">
                  <el-option v-for="child in item.valueListParse" :key="child.value" :label="child.value"
                             :value="child.value">
                  </el-option>
                </el-select>
              </template>

            </el-form-item>

          </template>

          <!-- 访客编码：前台发的实物卡编号，现场登记必填；不属租户表单模板，
               只随签到提交（enterCardNo → vt_record.enter_card_no） -->
          <el-form-item class="content-item" label="访客编码" :required="true">
            <el-input class="input-width" ref="visitorCardNo" v-model="formData.visitorCardNo"
                      placeholder="请填写访客卡上的编号"
                      @focus="onGetFocus({id: 'visitorCardNo'})" @blur="onLossFocus()"></el-input>
          </el-form-item>

          <div v-if="peerTemplate" class="content-sub">
            <el-button class="peer-item" @click="onAddPeerClick">添加同行人 +</el-button>
            <el-table v-if="peerList.length > 0" :data="peerList" border stripe style="width:   100%">
              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column prop="idCardNo" label="身份证" v-if="!icHidden"></el-table-column>
              <el-table-column prop="company" label="公司"></el-table-column>
              <el-table-column prop="tel" label="手机号"></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger" @click="onCardDel(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

          </div>

        </el-form>

        <div style="flex:none;display:flex;justify-content:center;gap:56px;padding:32px 0 8px">
          <button class="ta-btn ghost" style="width:320px" @click="onCancelClick">取 消</button>
          <button class="ta-btn primary" style="width:320px" @click="onEnsureClick">确 认</button>
        </div>
      </div>
    </div>

    <!-- 车牌键盘抽屉：禁用 Element 自带 modal——v-modal 挂在 body，而本页处于 .pad transform 画布
         （层叠上下文），画布内任何 z-index 都压不过 body 下的 v-modal，键盘会被遮罩盖住点不到；
         改为 wrapper 自绘半透明遮罩（仍在画布内，层级正确） -->
    <el-drawer
        :modal="false" size="880px" custom-class="car-kb-drawer" destroy-on-close
        :visible.sync="carKeyboardProp.isShow" direction="btt" :with-header="false"
        :before-close="beforeCarKeyboardClose">
      <car-keyboard :onConfirm="onCarKeyboardEnsure"
                    :onCancel="onCarKeyboardCancel" :onClear="onCarKeyboardClear"></car-keyboard>
    </el-drawer>

  </div>
</template>

<script>
import BackIcon from "@/components/BackIcon.vue";
import {addApply, getFields, visitorAdd} from "@/api/organize-api";
import MyNotifyDialog from "@/components/MyNotifyDialog.vue";
import CarKeyboard from "@/components/carkeyboard/CarKeyboard.vue";
import {mapMutations} from "vuex";
import {areaCheckMixin} from "@/utils/myMixins";
import {getApplyListByVisitCode, signEnter} from "@/api/visit-api";
import {myPath} from "@/utils/constant";


export default {
  name: "LocalAddInfo",
  components: {MyNotifyDialog, BackIcon, CarKeyboard},
  mixins: [areaCheckMixin],
  computed: {
    icHidden() {
      return this.$store.getters.icHidden
    },
    // 主表单身份证显隐/必填：与后台 访客信息>VISITOR_BOOK.idCardNo 对齐（1 不展示 / 2 选填 / 3 必填）
    idCardMode() {
      const v = this.$store.state.visitorConfigSetting
      return v && v.idCardNo ? Number(v.idCardNo) : 2
    },
  },
  props: {
    idCardvisitor: {
      type: Object,
      default: () => {
        return {name: "", idCardNo: "", score: 0}
      }
    }
  },


  data() {
    return {
      employee: {},

      title: "访客登记",

      defaultFormTemplate: [
        {
          id: 0,
          name: "visitorName",
          title: "姓名",
          type: "input",
          value: "",
          valueList: "",
          valueListParse: "",
          valueDefault: "",
          required: 1,
          rules: [{required: true}]
        },
        {
          id: 1,
          name: "visitorPhone",
          title: "手机号",
          type: "input",
          value: "",
          valueList: "",
          valueListParse: "",
          valueDefault: "",
          required: 1,
          rules: [{required: true}]
        },
        {
          id: 98001,
          name: "visitorIdCard",
          title: "身份证",
          type: "input",
          value: "",
          valueList: "",
          valueListParse: "",
          valueDefault: "",
          required: 1,
          rules: [{required: false}]
        },

      ],
      mainFormRules: {
        visitorName: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        visitorPhone: [
          {required: true, message: '请输入手机号', trigger: 'blur'}
        ],
      },

      formData: {
        visitorName: "",
        visitorPhone: "",
        visitorIdCard: null,
        visitorCardNo: "",
      },
      // 必填提示：页面内自绘弹层（Element MessageBox 挂 body，画布 transform 下按钮点不动）
      tip: {show: false, title: "提示", msg: "", okText: "知道了"},
      formTemplate: [],

      hasPeer: true,
      peerTemplate: null, // 同行人
      peerList: [], // 同行人列表
      peerAddForm: {
        name: "",
        company: "",
        tel: "",
        idCardNo: "",
      },
      peerRules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        company: [
          {required: true, message: '请输入所在公司', trigger: 'blur'}
        ],
        tel: [
          {required: true, message: '请输入手机号', trigger: 'blur'}
        ]
      },

      signOutTime: "",

      // dialog
      dialogVisible: false,
      scollValue: 0,

      carKeyboardProp: {
        isShow: false,
        formModelName: "",
      },

    }
  },

  mounted() {
    this.employee = this.$route.params.employee
    // 子路由直接刷新时 HomePage 未挂载、store 无配置，兜底拉取（正常流程 HomePage 已拉过，配置已就绪则跳过）
    if (!this.$store.state.visitorConfigSetting || this.$store.state.visitorConfigSetting.idCardNo === undefined) {
      this.$store.dispatch("requestVisitorConfigSetting")
    }

    getFields().then(({data}) => {
      console.log("LocalAddInfo getFields", data)
      if (data.code === 200) {
        data.data.formItems.forEach(item => {
          console.log("LocalAddInfo getFields item =>", item)
          if (item.valueList) {
            item.valueListParse = JSON.parse(item.valueList)
          }
          if (item.required) {
            this.mainFormRules[item.name] = [{required: true, message: '必填项', trigger: 'blur'}]
          } else {
            this.mainFormRules[item.name] = [{required: false}]
          }
          if (item.type !== "accompany") {
            this.formTemplate.push(item)
          } else {
            this.peerTemplate = item
          }
        })
      } else {
        console.error("LocalAddInfo getFields", data.code, data.msg)
        this.showNetErrMsg()
      }
    }).catch((err) => {
      console.error("LocalAddInfo getFields", err)
      this.showNetErrMsg()
    })

    this.setupAreaInfo()
  },// end mounted

  methods: {
    // 返回到首页
    ...mapMutations(['setAreaInfo']),

    // 身份证校验规则随后台配置切换（选填/必填均校验格式，空值放行由 required 控制）
    applyIdCardRule() {
      const icValidator = (rule, value, callback) => {
        if (!value) return callback()
        const icRegex = /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/
        if (!icRegex.test(value)) return callback(new Error('身份证号码错误'))
        callback()
      }
      if (this.idCardMode === 3) {
        this.mainFormRules.visitorIdCard = [
          {required: true, message: '请输入身份证号', trigger: 'blur'},
          {validator: icValidator, trigger: 'blur'}
        ]
      } else {
        this.mainFormRules.visitorIdCard = [{required: false}, {validator: icValidator, trigger: 'blur'}]
      }
    },

    onCancelClick() {
      this.$router.push({name: this.myPath.home})
    },

    //  获取访客
    async getVisitor() {
      let name = this.formData.visitorName
      let tel = this.formData.visitorPhone
      let idCard = this.formData.visitorIdCard
      let visitor = {}
      visitor.isBlack = false

      try {
        const response = await visitorAdd(name, tel, null, idCard)
        console.log("LocalAddInfo visitorLogin", response)
        if (response.data.code === 600) {
          visitor.isBlack = true
          return visitor
        }
        visitor = response.data.data
      } catch (err) {
        console.log("LocalAddInfo visitorLogin err =>", err)
        this.showNetErrMsg()
      }
      return visitor
    },

    // 获取同行人code列表
    async getPeerCodes() {
      if (!this.hasPeer || this.peerList.length === 0) {
        return null
      }

      let peerList = this.peerList
      let peerVisitorCodes = []
      for (let i = 0; i < peerList.length; i++) {
        try {
          const response = await visitorAdd(peerList[i].name, peerList[i].tel, peerList[i].company, peerList[i].idCardNo)
          console.log("LocalAddInfo visitorLogin", response.data)
          peerVisitorCodes.push(response.data.data.code)
        } catch (err) {
          console.log("LocalAddInfo visitorLogin err =>", err)
          this.showNetErrMsg()
        }
      }
      let result = peerVisitorCodes.join("|")
      return result
    },

    getFormItems() {
      this.formTemplate.forEach(item => {
        item.value = this.formData[item.name]
      })
      return this.formTemplate
    },

    showTip(msg) {
      this.tip = {show: true, title: "提示", msg: msg, okText: "知道了"}
    },

    onEnsureClick() {
      // 访客编码（前台发的实物卡编号）必填：没填直接弹层拦住，不进入登记/签到
      const visitorCardNo = (this.formData.visitorCardNo || "").toString().trim()
      if (!visitorCardNo) {
        this.showTip("请填写访客编码（访客卡上的编号）后再确认登记。")
        return false
      }
      this.formData.visitorCardNo = visitorCardNo

      if (!this.checkPhoneNo()) {
        this.$message.error("手机号不能与同行人手机号相同")
        return false
      }
      let date = new Date()
      let dateStr = date.getFullYear() + "-" + ('0' + (date.getMonth() + 1)).slice(-2) + "-" + ('0' + date.getDate()).slice(-2) + " " + ('0' + date.getHours()).slice(-2) + ":" + ('0' + date.getMinutes()).slice(-2) + ":" + ('0' + date.getSeconds()).slice(-2)
      this.formData['startTime'] = dateStr
      this.formData["endTime"] = dateStr
      this.$refs.mainForm.validate(async (valid) => {
        if (valid) {
          // 提交链整体兜底：任何异常（接口/数据/区域校验）都必须给用户反馈，
          // 严禁静默失败（历史上 areaInfo 异常曾导致点确认毫无反应）
          try {
            console.log("LocalAddInfo onEnsureClick form check pass")
            let apply = {}
            apply.employeeId = this.employee.id
            apply.employeeCode = this.employee.code

            let visitor = await this.getVisitor()
            console.log("LocalAddInfo onEnsureClick visitor =>", visitor)
            if (visitor.isBlack) {
              this.notify = {title: "登记结果", show: true, success: false, msg: "访客禁止现场登记",}
              return false
            }
            apply.visitorCode = visitor.code
            apply.visitorId = visitor.id

            apply.type = "SCENE_APPLY"
            apply.accompanies = await this.getPeerCodes()

            let dateTime = new Date()
            let date = dateTime.getFullYear() + "-" + ('0' + (dateTime.getMonth() + 1)).slice(-2) + "-" + ('0' + dateTime.getDate()).slice(-2)
            apply.beginDate = date
            apply.endDate = date
            apply.beginTime = ('0' + dateTime.getHours()).slice(-2) + ":" + ('0' + dateTime.getMinutes()).slice(-2) + ":" + ('0' + dateTime.getSeconds()).slice(-2)
            apply.endTime = apply.beginTime

            apply.forms = this.getFormItems()
            apply.checkoutTime = this.signOutTime
            apply.device = this.areaId
            if ((this.areaInfo || {}).verify === 1) {
              apply.entryArea = this.areaId
            } else {
              apply.entryArea = null
            }
            console.log("LocalAddInfo onEnsureClick apply =>", apply)

            this.doAddApply(apply)
          } catch (err) {
            console.error("LocalAddInfo onEnsureClick err =>", err)
            this.notify = {title: "登记结果", show: true, success: false, msg: "登记失败，请重试或联系工作人员",}
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },

    doAddApply(formData) {
      addApply(formData).then(({data}) => {
        console.log("LocalAddInfo addApply", data)
        if (data.code === 200) {
          this.doOnAddApplySuccess(formData, data.data)
        } else {
          console.log("LocalAddInfo addApply false", data.code, data.msg)
          this.notify = {title: "登记结果", show: true, success: false, msg: "登记失败，错误码:" + data.code,}
        }
      }).catch(err => {
        console.log("LocalAddInfo addApply err =>", err)
        this.notify = {title: "登记结果", show: true, success: false, msg: "登记失败,网络异常",}
      })
    },

    onDialogCancelClick() {
      this.dialogVisible = false
      this.peerAddForm = {name: "", company: "", tel: "", idCardNo: ""}
    },
    onDialogEnsureClick() {
      this.$refs.formPeerAdd.validate((valid) => {
        if (valid) {
          // 检查手机号是否重复
          let filter = this.peerList.filter(item => {
            return item.tel === this.peerAddForm.tel
          });
          if (filter.length > 0) {
            this.$message.error("手机号不能重复")
            return false
          }
          if (this.peerAddForm.tel === this.formData.visitorPhone) {
            this.$message.error("手机号不能与访客手机号相同")
            return false
          }

          this.dialogVisible = false
          this.peerList.push({
            name: this.peerAddForm.name,
            company: this.peerAddForm.company ? this.peerAddForm.company : null,
            tel: this.peerAddForm.tel,
            idCardNo: this.peerAddForm.idCardNo ? this.peerAddForm.idCardNo : null
          })
          this.peerAddForm = {name: "", company: "", tel: "", idCardNo: ""}
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 选择框改变监听
    // 事由 chips 点击：再点已选中项 = 清空（对齐原 select 的 clearable），并保留依赖字段联动。
    // 必须用 $set：formData 初始只声明了姓名/手机号/身份证三个 key，事由等字段是运行时
    // 新增 key，普通赋值在 Vue 2 里不是响应式，选中高亮不会出现（值虽写入但视图不动）
    onReasonChipClick(item, child) {
      const next = this.formData[item.name] === child.value ? "" : child.value
      this.$set(this.formData, item.name, next)
      this.onSelectChange(item, item.valueListParse, next)
    },

    onSelectChange(item, valueList, selectValue) {
      if (item.valueSelect && item.valueSelect.dependField) {
        this.dealDependFieldRemove(item.valueSelect)
      }
      item.valueSelect = null

      let i
      for (i = 0; i < valueList.length; i++) {
        if (valueList[i].value === selectValue && valueList[i].dependField || valueList[i].signOutTime) {
          this.dealDependFieldAdd(valueList[i])
          item.valueSelect = valueList[i]
          break;
        }
      }
    },
    // 处理依赖字段移除
    dealDependFieldRemove(selectValue) {
      if (selectValue.signOutTime) {
        this.signOutTime = ""
      }
      let filter = this.formTemplate.filter(formItem => {
        return formItem.id === selectValue.dependField
      });

      if (filter.length > 0) {
        filter[0].extRequired = 0
        if (filter[0].required) {
          this.mainFormRules[filter[0].name] = [{required: true, message: '必填项', trigger: 'blur'}]
        } else {
          this.mainFormRules[filter[0].name] = [{required: false}]
        }

        if (selectValue.isReadyOnly) {
          filter[0].extIsReadyOnly = false
          this.formData[filter[0].name] = ""
        }
      }
    },

    // 处理依赖字段添加
    dealDependFieldAdd(selectValue) {
      if (selectValue.signOutTime) {
        this.signOutTime = selectValue.signOutTime
      }
      if (!selectValue.dependField) {
        return
      }
      let filter = this.formTemplate.filter(formItem => {
        return formItem.id === selectValue.dependField
      });
      if (filter.length > 0) {
        filter[0].extRequired = 1
        this.mainFormRules[filter[0].name] = [{required: true, message: '必填项', trigger: 'blur'}]

        if (selectValue.isReadyOnly) {
          filter[0].extIsReadyOnly = true
          this.formData[filter[0].name] = selectValue.readyValue
        }
      }
    },

    setCarKeyboardState(value) {
      console.log("setCarKeyboardState", value)
    },

    onCarKeyboardDone(value) {
      console.log("setCarKeyboardState", value)
    },

    onAddPeerClick() {
      console.log("onAddPeerClick")
      this.dialogVisible = true
    },
    onCardDel(item) {
      let index = this.peerList.indexOf(item)
      this.peerList.splice(index, 1)
    },


    // 处理键盘弹出时，页面滚动的
    onGetFocus(formItem) {
      // 模板渲染的 ref 是数组（v-for 内），单独的 ref 是组件实例，两种都要兼容
      const refs = this.$refs[formItem.id]
      const inst = Array.isArray(refs) ? refs[0] : refs
      const view = inst && inst.$el
      if (!view) return
      let rect = view.getBoundingClientRect()
      let top = rect.top

      console.log("select view margin top " + top)
      if (top > 250) {
        let scollValue = top - 250
        let parentView = this.$refs.mainForm.$el
        parentView.scrollTo(0, scollValue)
        this.scollValue = scollValue
      } else {
        this.scollValue = 0
      }
    },
    // 处理聚焦结束后，页面滚动的恢复
    onLossFocus() {
      if (this.scollValue > 0) {
        let parentView = this.$refs.mainForm.$el
        parentView.scrollTo(0, -this.scollValue)
      }
      this.scollValue = 0
    },
    onMainLossFocus(item) {
      if (item.name === "visitorPhone") {
        if (!this.checkPhoneNo()) {
          this.$message.error("手机号不能与同行人手机号相同")
        }
      }
    },
    checkPhoneNo() {
      let visitorPhoneNo = this.formData.visitorPhone
      if (visitorPhoneNo && this.peerList.length > 0) {
        let filter = this.peerList.filter(item => {
          return item.tel === visitorPhoneNo
        });
        return filter.length === 0
      }
      return true
    },
    onNotifyDialogClose() {
      this.notify.show = false
      if (this.notify.success) {
        this.$router.push({name: this.myPath.home})
      }
    },
    beforeCarKeyboardClose(done) {
      // formData[item.name]
      done()
    },

    onCarInputClick(item) {
      console.log("onCarInputClick, @@@", item)
      this.carKeyboardProp.formModelName = item.name
      this.carKeyboardProp.isShow = true
    },
    onCarKeyboardEnsure(value) {
      console.log("onCarKeyboardEnsure", value)
      this.formData[this.carKeyboardProp.formModelName] = value
      this.carKeyboardProp.isShow = false

    },
    onCarKeyboardCancel() {
      console.log("onCarKeyboardCancel")
      this.carKeyboardProp.isShow = false
    },
    onCarKeyboardClear() {
      console.log("onCarKeyboardClear")
      this.formData[this.carKeyboardProp.formModelName] = ""
    },

    doOnAddApplySuccess(apply, applyMsg) {
      //  【访客机】现场登记如果是审批通过，跳转到访客单打印页
      let visitorCode = apply.visitorCode
      getApplyListByVisitCode(visitorCode).then(({data}) => {
        console.log("getApplyListByVisitCode", data)
        let findApply = data.data.find(item => {
          return item.id === applyMsg.id
        })
        if (findApply && findApply.state === "PASS") {
          this.doSignEnter(findApply, visitorCode, this.formData.visitorCardNo)
        } else {
          this.notify = {title: "登记结果", show: true, success: true, msg: "登记成功",}
        }

      }).catch((err) => {
        this.notify = {title: "登记结果", show: true, success: true, msg: "登记成功",}
      })
    },

    async doSignEnter(applyInfo, visitorCode, enterCardNo) {
      let printSw = this.JavaBaseInfo.getBaseInfo("Setting.printEnterInfo") === "1" // 默认关，需显式开启
      let applyId = applyInfo.id
      let deviceId = this.$store.state.deviceId
      let areaId = this.$store.state.areaId
      let photoKey, certPhoto,  icCompareResult, icCompareScore = null
      signEnter(applyId, visitorCode, deviceId, areaId, photoKey, certPhoto, icCompareResult, icCompareScore, enterCardNo).then(({data}) => {
        console.log("signEnter result", data)
        if (data.code === 200) {
          if (printSw) {
            this.jumpToPrintPage(data.data)
          } else {
            this.notify = {title: "登记结果", show: true, success: true, msg: "登记成功",}
          }
        } else {
          this.notify = {title: "登记结果", show: true, success: true, msg: "登记成功",}
        }
      }).catch(() => {
        this.notify = {title: "登记结果", show: true, success: true, msg: "登记成功",}
      })
    },

    jumpToPrintPage(signResult) {
      console.log("jumpToPrintPage  pinVisitor" + JSON.stringify(signResult))
      let applyInfo = signResult.apply
      let visitor = signResult.visitor
      let reasonObj = applyInfo.forms.find(item => item.name === "reason")
      let reason = reasonObj ? reasonObj.value : ""
      let carObj = applyInfo.forms.find(item => item.name === "carNumber")
      let car = carObj ? carObj.value : ""
      console.log("jumpToPrintPage  userInfo" + JSON.stringify(visitor))
      let printData = {
        visitorName: visitor.name,
        visitorCode: signResult.pinCode,
        visitorCompany: visitor.company,
        visitorReason: reason,
        employName: applyInfo.employee.name,
        employDepartment: applyInfo.employee.departmentName,
        visitorCar: car,
        visitorTime: applyInfo.beginDate + " " + applyInfo.beginTime,
        visitorGoods: "",
        idCardNo: visitor.ic,
        visitorPhone: visitor.tel,
      }
      this.$router.push({name: myPath.printPage, params: {printData: printData}})
    },


  }, // end methods

  watch: {
    idCardMode: {
      handler: function () {
        this.applyIdCardRule()
      },
      immediate: true
    },
    idCardvisitor: {
      handler: function (newVal, oldVal) {
        console.log("LocalAddInfo watch idCardvisitor", newVal)
        if (newVal) {
          this.formData.visitorName = newVal.name
          this.formData.visitorIdCard = newVal.idCardNo
        }
      },
      deep: true
    }
  }

}
</script>

<style scoped lang="less">


.content-main-form {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  width: 100%;
  overflow: auto;
  padding: 0 8px;
}

.content-item {
  flex-basis: calc(50% - 44px);
  margin: 12px 24px 28px 0;

  /deep/ .el-form-item__label {
    font-size: 32px;
    color: var(--ink-2);
    line-height: 44px;
  }

  .input-width {
    width: 100%;
  }
}

.content-sub {
  flex-basis: 100%;
  margin: 12px 0 0;
  padding: 0;

  .peer-item {
    width: 100%;
    margin: 10px 0;
  }
}

.content-main {
  display: flex;
  flex-direction: column;
  //flex-wrap: wrap;
  //justify-content: space-around;
  //align-content: flex-start;

  margin: 15px;
  border-radius: 15px;

  width: 90%;
  flex: 5;
  height: calc(100% - 30px);

  // 内容超出时，滚动条
  overflow: auto;
}

/deep/ .el-drawer__wrapper {
  // :modal=false 后自绘遮罩（替代 body 下的 v-modal，见模板注释）
  background: rgba(0, 0, 0, 0.5);
}

/deep/ .el-drawer.car-kb-drawer {
  padding-top: 15px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;

  // theme-a 画布（2048×1280）下键盘沿用老项目手机级 px 尺寸，按键仅 ~42px 高难以命中：
  // 整体 zoom 放大（等比缩放布局与命中区域），并收窄容器避免放大后超出画布
  #rid-m-201708101425 {
    zoom: 1.8;
    width: 1120px;
    margin: 0 auto;
  }
}

// 必填提示弹层：画布内自绘（Element MessageBox 在 2048 画布 transform 下按钮点不动）
.tip-mask {
  position: fixed;
  inset: 0;
  z-index: 300;
  background: rgba(15, 18, 14, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
}

.tip-card {
  width: 880px;
  padding: 56px 64px 48px;
  border-radius: 28px;
  background: #fff;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);
  text-align: center;
}

.tip-title {
  font-size: 44px;
  font-weight: 700;
  color: #1a1d21;
}

.tip-msg {
  margin-top: 28px;
  font-size: 34px;
  line-height: 1.6;
  color: #4b5563;
}

.tip-ok {
  width: 320px;
  height: 96px;
  font-size: 36px;
  margin-top: 44px;
}

</style>
